import { PAGE } from '@/constants/page.js'
export const getPage = (pageid) => {
  switch (pageid) {
    case '108234815144840':
    case '110981841237323':
    case '1037700739663223':
    case '101542172593323':
      return 'nestle'
    case '101802199107897':
      return 'secap'
    case '111895158162143':
    case '157333504139024':
      return 'hopinnhr'
    case '106004118709627':
    case '150765918293329':
      return 'gpf'
    case '110880794986721':
    case '104039299068829':
      return 'yasale-ac'
    case '108586555240680':
    case '102071912676867':
      return 'nongtungjai'
    case '103746389114044':
    case '105763258933863':
    case '109966648492321':
      return 'summithr'
    case '105432182130709':
    case '462339517184685':
      return 'cityfresh'
    case '100305558382056':
    case '103174965660875':
      return 'dtac-gaming'
    case '107879035335045':
    case '1688468514708248':
      return 'mtc'
    case '102549712095297':
    case '105387828535129':
      return 'nextcapital'
    case PAGE.TRUEIDTEST:
    case PAGE.TRUEID:
      return 'trueid'
    case '100701258941039':
      return 'yasale'
    case '146830725169369':
      return 'yasale-test'
    case '115414076948160':
    case '396306053873110':
      return 'thailandpostmart'
    case '1637674519806774':
      return 'Aira'
    case '105017609020919':
      return 'Airatest'
    case '104614765775640':
    case '101744349120148':
      return 'nt'
    case '103238152679894':
    case '110614952012250':
    case '178316699484910':
      return 'autocash'
    case '103406769335661':
    case '109881831628138':
    case '306810373443838':
    case '118589437881324':
    case '181147355415089':
      return 'somwang'
    case '116093288022738':
      return 'sprc'
    case '102901306098188':
      return 'demo'
    case '104808655743823':
    case '353174701482518':
      return 'root'
    case '105189164178822':
    case '109677593778236':
      return 'uu'
    case '113442914924067':
      return 'jamsai'
    case '330339053719456':
    case '105314948276699':
      return 'tero'
    case '103142525784844':
    case '122533807607458':
      return 'truecorp'
    case '130202230174656':
      return 'mordee'
    case '102126962268028':
    case '111901618984646':
      return 'prudential'
    case '256597397530627':
    case '450523781782424':
      return 'phyathai'
    case '101536496332228':
    case '234654293072791':
      return 'tcp-broadcast'
    case '261510760382127':
    case '233952216240':
      return 'baac'
    case '247498961787606':
    case '1722484263688':
      return 'tigerpoly'
    case '141294219066088':
      return 'smom'
    case '704198559717443':
      return 'delta'
    case '232334833287561':
    case '337421534322225':
      return 'toa-megapaint'
    case '315127695020973':
      return 'sso'
    case '1718598395533':
      return 'superrich'
    case '1718600894134':
      return 'amaze'
    case '1727431998326':
    case '1726051377196':
      return 'skf'
    default:
      return 'default'
  }
}



// WEBPACK FOOTER //
// ./src/config/customize.js